import { render, staticRenderFns } from "./policyCovered.vue?vue&type=template&id=6526e713&scoped=true"
import script from "./policyCovered.vue?vue&type=script&lang=js"
export * from "./policyCovered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6526e713",
  null
  
)

export default component.exports